import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';
import { lotamePixel } from '../../js/utility';

import { connect } from 'react-redux';
import { toggleLightbox } from '../../actions/lightbox';

class OnRouteChange extends Component {
  constructor(props) {
    super(props);
  }

  updateGA(location) {
    ReactGA.pageview(location.pathname + location.search);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
      // Lotame pixel every time route changes
      lotamePixel();
      this.updateGA(this.props.location);
      this.props.toggleLightbox(false);

      // Remove redirect uri
      if (localStorage.getItem('uriStorage') || localStorage.getItem('h')) {
        if (
          prevProps.location.pathname === '/verify-account' &&
          this.props.location.pathname === '/login'
        ) {
          this.props.history.push(
            `/login?h=${localStorage.getItem('h')}&uri=${localStorage.getItem(
              'uriStorage'
            )}`
          );
          return null;
        }
        if (this.props.location.pathname !== '/verify-account') {
          localStorage.removeItem('uriStorage');
          localStorage.removeItem('h');
        }
      }
    }
  }

  render() {
    return this.props.children;
  }
}

OnRouteChange.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  toggleLightbox: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  toggleLightbox
};

export default connect(
  null,
  mapDispatchToProps
)(withRouter(OnRouteChange));
